/** Matches server `TeamId` — wire values stay `"A"` / `"B"`. */
export enum TeamId {
  A = "A",
  B = "B",
}

export function isTeamId(value: unknown): value is TeamId {
  return value === TeamId.A || value === TeamId.B;
}

export function opposingTeam(team: TeamId): TeamId {
  return team === TeamId.A ? TeamId.B : TeamId.A;
}

/** Post–Atta challenge chain (server `ChallengeStep`). */
export enum ChallengeStep {
  Addu = "addu",
  Sharathu = "sharathu",
  BeSharathu = "be_sharathu",
}

/** Challenge responses (server `ChallengeAction`). */
export enum ChallengeAction {
  Addu = "Addu",
  Sharathu = "Sharathu",
  BeSharathu = "BeSharathu",
  Pass = "Pass",
}

export interface CardDTO {
  suit: string;
  rank: string;
}

export interface PlayerInfo {
  name: string | null;
  uuid: string;
  seatIndex: number;
  teamId: TeamId;
  isBot?: boolean;
}

export interface PlayedCard {
  playerIndex: number;
  card: CardDTO;
}

export interface RoundSummaryEntry {
  roundNumber: number;
  cards: PlayedCard[];
  winnerIndex: number;
  winnerTeam: TeamId;
  points: number;
  isLastRound: boolean;
  lastRoundBonus: number;
}

export interface GameResult {
  callerTeam: TeamId;
  callerTeamMarks: number;
  oppositionMarks: number;
  stake: number;
  oppositionWon: boolean;
  totalMarks: number;
  winTarget: number;
  lastRoundBonus: number;
  trumpSuit: string | null;
  roundSummary: RoundSummaryEntry[];
}

export type GamePhase =
  | "WAITING"
  | "BIDDING"
  | "CHALLENGE"
  | "TRUMP_PICK"
  | "PLAYING"
  | "GAME_OVER";

/** Maps backend rank name to card SVG code */
export const rankToCode: Record<string, string> = {
  Ace: "A",
  Ten: "10",
  King: "K",
  Queen: "Q",
  Jack: "J",
  Nine: "9",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "10": "10",
  J: "J",
  Q: "Q",
  K: "K",
  A: "A",
};

/** Maps backend suit name to card SVG code */
export const suitToCode: Record<string, string> = {
  Clubs: "C",
  Diamonds: "D",
  Hearts: "H",
  Spades: "S",
};

/** Converts a CardDTO to the codes used by the cardsJS SVG library */
export const toCardCode = (card: CardDTO): { value: string; suit: string } => ({
  value: rankToCode[card.rank] ?? card.rank,
  suit: suitToCode[card.suit] ?? card.suit,
});
